import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ValidatorService } from '@asambleas-services/validators/validator.service';
import { LoginService } from '@asambleas-services/login/login.service';
import { LoadService } from '@asambleas-components/loader/loader.service';

@Component({
    selector: 'app-restore-password',
    templateUrl: './restore-password.component.html',
    styleUrls: ['./restore-password.component.scss']
})
export class ModalRestorePasswordComponent implements OnInit {

    form: FormGroup;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<ModalRestorePasswordComponent>,
        private customValidator: ValidatorService,
        private dialog: MatDialog,
        private loginServ: LoginService,
        private loader: LoadService
    ) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            mail: ['', [
                Validators.required,
                this.customValidator.validateEmail.bind(this),
                Validators.minLength(4).bind(this)
            ]]
        })
    }

    // Dejando que el padre obtengo el dato y envie la petición de restauración de contraseña
    sendPetition() {
        if (this.form.valid) {

            let loader = this.loader.createLoad()
            loader.open()

            let petition = this.loginServ.sendRestorationPasswordMail({ email: this.form.value['mail'] });
            petition.subscribe((resp) => {
                console.log(resp);
                loader.close();
                this.dialogRef.close(this.form.value)
            }, error => {
                console.error('Something bad happend trying to send restoration mail');
                loader.close();
            });
        }
    }

    back() {
        this.dialogRef.close(null)
    }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/restore-password/restore-password.component.ts